import { Box, Button, Icon } from '@chakra-ui/react';
import type { ComponentProps } from 'react';
import { LuChevronDown } from 'react-icons/lu';

import {
  ADVISOR_PANEL_NEUTRAL_100,
  ADVISOR_PANEL_NEUTRAL_200,
  ADVISOR_PANEL_NEUTRAL_400,
  ADVISOR_PANEL_NEUTRAL_50_BG,
} from './advisor-panel-tokens';

type ButtonProps = ComponentProps<typeof Button>;

export type AdvisorScrollToLatestPillProps = Omit<ButtonProps, 'children' | 'type' | 'size' | 'aria-label'> & {
  onClick: () => void;
};

export function AdvisorScrollToLatestPill({ onClick, ...buttonProps }: AdvisorScrollToLatestPillProps) {
  return (
    <Box position="absolute" bottom={1} left="50%" transform="translateX(-50%)" zIndex={2} pointerEvents="none">
      <Button
        type="button"
        variant="outline"
        w="38px"
        h="38px"
        minW="38px"
        minH="38px"
        p={0}
        shadow="0 1px 4px rgba(23, 24, 24, 0.08)"
        pointerEvents="auto"
        borderRadius="full"
        borderColor={ADVISOR_PANEL_NEUTRAL_100}
        bg="white"
        color={ADVISOR_PANEL_NEUTRAL_400}
        aria-label="Jump to latest message"
        onClick={onClick}
        _hover={{ bg: 'white', borderColor: ADVISOR_PANEL_NEUTRAL_200 }}
        _active={{ bg: ADVISOR_PANEL_NEUTRAL_50_BG }}
        {...buttonProps}
      >
        <Icon as={LuChevronDown} boxSize={5} strokeWidth={1.8} />
      </Button>
    </Box>
  );
}

/** @alias {@link AdvisorScrollToLatestPill} */
export const AgentScrollToLatestPill = AdvisorScrollToLatestPill;

/** @alias {@link AdvisorScrollToLatestPillProps} */
export type AgentScrollToLatestPillProps = AdvisorScrollToLatestPillProps;
